import type { StudioRuntimeSettings } from './studioApi';
/** Editing one sparse group must not materialize defaults or erase another group's overrides. */
export const updateRuntimeGroup = <K extends 'speech' | 'session' | 'preCall'>(
  current: StudioRuntimeSettings | null | undefined,
  key: K,
  group: StudioRuntimeSettings[K],
): StudioRuntimeSettings | null => {
  const result: StudioRuntimeSettings = { ...current, schemaVersion: 1 };
  if (group === undefined || !Object.keys(group).length) delete result[key];
  else result[key] = group;
  return result.speech !== undefined || result.session !== undefined || result.preCall !== undefined
    ? result
    : null;
};
